export default function parseContent(content) {
  var contentObj = {
    type: 'container',
    content: [
      {
        type: 'row',
        content: [
          {
            type: 'col',
            content: {
              type: 'text',
              content: ''
            }
          }
        ]
      }
    ]
  };
  if (!content) return contentObj;
  try {
    let parsed = JSON.parse(content);
    // console.log("parsed",parsed)
    if (parsed && parsed.type == 'container') contentObj = parsed;
  } catch (err) {
    console.warn('parseContent err:', err);
  }
  return contentObj;
}
